import { useEffect, useState } from "react";
import api from "@/lib/api";
import { money, fmtDateTime, paymentModeLabel } from "@/lib/format";
import { FileClock } from "lucide-react";

const ACTIONS = {
  create: "Création", update: "Modification", status_change: "Changement de statut", process: "Mise en traitement",
  cancel: "Annulation", restore: "Restauration", correct_payment: "Correction paiement", reschedule: "Reprogrammation",
  assign: "Attribution livreur", collect: "Collecte", deliver: "Livraison",
};
const FIELDS = {
  items: "Services", discount: "Remise", delivery_fee: "Frais de livraison", delivery_waived: "Livraison offerte",
  total: "Total", amount: "Montant payé", mode: "Mode de paiement", collect_date: "Date collecte",
  collect_time: "Heure collecte", delivery_date: "Date livraison", delivery_time: "Heure livraison",
  comment: "Commentaire", pieces: "Pièces", weight: "Poids (kg)", reason: "Motif", courier: "Livreur", number: "N°",
};
const MONEY = ["discount", "delivery_fee", "total", "amount"];

const fmtVal = (k, v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (Array.isArray(v)) return v.length ? v.join(", ") : "—";
  if (typeof v === "boolean") return v ? "Oui" : "Non";
  if (MONEY.includes(k)) return money(v);
  if (k === "mode") return paymentModeLabel[v] || v;
  return String(v);
};

const Detail = ({ k, v }) => {
  if (k === "payment") {
    return <div>Paiement : <b>{money(v.amount || 0)}</b>{v.mode ? ` · ${paymentModeLabel[v.mode] || v.mode}` : ""}</div>;
  }
  if (k === "from" || k === "to") return null;
  const label = FIELDS[k] || k;
  if (v && typeof v === "object" && !Array.isArray(v) && ("from" in v || "to" in v)) {
    return <div>{label} : <span className="text-slate-400 line-through">{fmtVal(k, v.from)}</span> → <b>{fmtVal(k, v.to)}</b></div>;
  }
  return <div>{label} : <b>{fmtVal(k, v)}</b></div>;
};

export default function OrderAuditLog({ orderId, refreshKey }) {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get(`/orders/${orderId}/audit`).then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, [orderId, refreshKey]);

  return (
    <div data-testid="od-audit-log">
      <div className="flex items-center gap-2 font-semibold text-slate-700 mb-2 text-sm">
        <FileClock className="w-4 h-4" /> Historique des modifications
      </div>
      {logs.length === 0 && <p className="text-xs text-slate-400" data-testid="od-audit-empty">Aucune modification enregistrée.</p>}
      <div className="space-y-2">
        {logs.map((l) => {
          const d = l.details || {};
          const isStatus = "from" in d && "to" in d && !d.amount;
          return (
            <div key={l.id} data-testid={`od-audit-entry-${l.id}`} className="rounded-lg border border-slate-100 bg-slate-50/60 p-2.5 text-xs">
              <div className="flex flex-wrap items-center gap-x-2 text-slate-500">
                <b className="text-slate-800">{ACTIONS[l.action] || l.action}</b>
                <span>· {fmtDateTime(l.at)}</span>
                <span>· par <b className="text-slate-700">{l.user_name || "Système"}</b></span>
              </div>
              <div className="mt-1 space-y-0.5 text-slate-600">
                {isStatus && <div>Statut : <span className="text-slate-400">{d.from || "—"}</span> → <b>{d.to}</b></div>}
                {Object.entries(d).map(([k, v]) => <Detail key={k} k={k} v={v} />)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
